export const Dew = () => (
  <svg width="43" height="51" viewBox="0 0 43 51" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter
        x="-40.6%"
        y="-31.1%"
        width="181.3%"
        height="162.2%"
        filterUnits="objectBoundingBox"
        id="w7fdhkyz4a"
      >
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g transform="translate(8.919 8.944)" filter="url(#w7fdhkyz4a)" fill="#FFF" fillRule="nonzero">
      <path d="M22.147 0c-.979 0-1.918.396-2.61 1.1a3.788 3.788 0 0 0-1.081 2.654c0 .996.389 1.95 1.08 2.655a3.66 3.66 0 0 0 2.61 1.1 3.66 3.66 0 0 0 2.611-1.1 3.787 3.787 0 0 0 1.081-2.655c0-.996-.389-1.95-1.081-2.654a3.661 3.661 0 0 0-2.61-1.1zm0 1.877c.49 0 .959.198 1.305.55.346.352.54.83.54 1.327 0 .498-.194.975-.54 1.327a1.83 1.83 0 0 1-1.305.55 1.83 1.83 0 0 1-1.305-.55 1.893 1.893 0 0 1-.54-1.327c0-.498.194-.975.54-1.327a1.83 1.83 0 0 1 1.305-.55zM22.147 21.962c0 6.532-4.958 11.826-11.074 11.826C4.958 33.788 0 28.494 0 21.962 0 15.431 11.073 0 11.073 0s11.074 15.43 11.074 21.962z" />
    </g>
  </svg>
);
